import Superscript from "@/components/ui/superscript";
export const keyFacts = [
  {
    title: <>Number of internal migrants</>,
    description: (
      <>
        10.5 million
        <Superscript
          path="https://nepalindata.com/media/resources/items/20/bNLFS-III_Final-Report.pdf"
          index="1"
        />{" "}
        lifetime migrants
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    title: <>Migration trends</>,
    description: (
      <>
        65%
        <Superscript path="https://www.migrantresilience.org/" index="2" /> of
        all migrants move from rural to urban areas in Nepal
      </>
    ),
    icon: "/images/icons/urbanization.png",
  },
  {
    title: <>Key destination areas</>,
    description: (
      <>
        Kathmandu{" "}
        <Superscript
          path="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3060790/"
          index="3"
        />
      </>
    ),
    icon: "/images/icons/destination (2).png",
  },
  {
    title: (
      <>
        Prominent sectors of employment for migrants
        <Superscript
          path="https://nepalindata.com/media/resources/items/20/bNLFS-III_Final-Report.pdf"
          index="4"
        />{" "}
      </>
    ),
    description: (
      <>
        Service sector
        <Superscript path="https://www.migrantresilience.org/" index="5" />{" "}
        (42.7%), construction (12.6%) and manufacturing (9.9).
      </>
    ),
    icon: "/images/icons/job.png",
  },
];
export const climateImpacts = [
  {
    description: (
      <>
        Climate migration: There are 345,018
        <Superscript
          path="https://actionaid.org/sites/default/files/publications/ActionAid%20CANSA%20-%20South%20Asia%20Climate%20Migration%20report%20-%20Dec%202020_3.pdf"
          index="7"
        />{" "}
        estimated climate migrants in the country. An estimated 1.3 million
        people are predicted to migrate by 2050 as a result of climate change
        <Superscript
          path="https://cansouthasia.net/wp-content/uploads/2021/02/Migration_Nepal_20_02_2021-1.pdf"
          index="8"
        />
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihoods are wage loss (74%) wage cut
        (68%) and crop loss (50%), and top three negative household impacts are
        food insecurity (83%), health issues (42%) and loss of access to water
        or sanitation services (37%) livelihoods impacts. (Sample size - 1494)
      </>
    ),
    icon: "/images/icons/impact.png",
  },
  {
    description: (
      <>
        Top three impacts at destination top three negative livelihood impacts
        are wage loss (87%), wage cut (49%), and employment related asset loss
        (17%), and top three negative household impacts are food insecurity
        (64%), health issues (63%), and loss of access to water and sanitation
        (37%). (Sample size - 734)
      </>
    ),
    icon: "/images/icons/home.png",
  },
];
export const stories = [
  {
    title: "No Escape: From Droughts to Floods",
    description: "",
    videoPath: "https://youtu.be/5ApJahjRnTY",
  },
  {
    title: "Crop Failure: Indebted by Climate Change",
    description: "",
    videoPath: "https://youtu.be/4sK5mY4YFok",
  },
];

export const partners = [
  {
    title: "Samari Utthan Sewa",
    logo: "/images/partners/Samari Utthan Sewa (SUS) logo.png",
    link: "https://samariutthan.org.np/",
  },
  {
    title: "NEEDS Nepal",
    logo: "/images/partners/NEEDS Nepal logo.jpg",
    link: "https://needsnepal.org.np/",
  },
  {
    title: "Nepal Mahila Ekata Samaj (NMES)",
    logo: "/images/partners/Nepal Mahila Ekata Samaj (NMES) logo.png",
    link: "http://www.mahilaekata.org/",
  },
];

export const seo = {
  slug: "/nepal",
  metaTitle: "Nepal | People’s Courage International, South & Southeast Asia",
  metaDescription:
    "PCI operates two initiatives in Nepal: Migrants Resilience Collaborative and the climate resilience initiative.",
};

export const jsonLd = {
  "@context": "http://www.schema.org",
  "@type": "Organization",
  name: "People’s Courage International",
  description:
    "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3206 10th Street NE, Washington",
    addressLocality: "DC",
    postalCode: "20017",
    addressCountry: "USA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1202-573-8727",
    contactType: "customer support",
  },
};

export const nepalInsights = [
  {
    heading:
      "Increase in rural to urban migration in the country has led to a loss of labour in rural areas:",
    text: `The most prominent labour movement in the country has been from the mountains to the Terai region in Nepal. Some districts have experienced an outmigration of up to half of their population.<sup><a href="https://publications.iom.int/system/files/pdf/mp_nepal_2019.pdf" target="_blank" rel="noreferrer">[9]</a></sup> Studies have shown that this has led to a shortage of agricultural labour in rural areas. In some regions of Nepal, rural communities use agricultural traditions like the <i>'parma'</i><sup>[10]</sup>, a reciprocal labour exchange system between households to supplement labour loss.<sup><a href="https://forestecosyst.springeropen.com/articles/10.1186/s40663-018-0155-x" target="_blank" rel="noreferrer">[11]</a></sup>`,
    image: "/images/nepal/insight-1.jpg",
    extra:
      "<span class='text-lightBlue'>[10]</span> The Parma system in Nepal is a reciprocal exchange of labour. Households come together to conduct similar work such as sowing or harvesting on each household farm during agricultural season. There is no payment involved, but every contributing household is intended to receive the same service in return.",
  },
  {
    heading:
      "Earthquakes and natural disasters – aggravated by climate change – have driven internal migration in the country:",
    text: `More than 80 percent of the total population of Nepal is at high risk from natural hazards like floods, landslides, earthquakes and Glacial Lake Outburst Floods (GLOF).<sup><a href="https://www.undp.org/nepal/publications/nepal-disaster-report-2017-road-sendai#:~:text=More%20than%2080%20percent%20of,period%20of%202015%20and%202016." target="_blank" rel="noreferrer">[12]</a></sup> Landslides exacerbate water scarcity and climate events can devastate entire villages, leading to increased internal migration. The Global Report on Internal Displacement (GRID,2023) estimated 93,000 internal displacement disasters in the country which led to 58,000 internally displaced people in 2022. Across South Asia, Nepal has the fifth highest internally displaced people.<sup><a href="https://www.internal-displacement.org/global-report/grid2023/" target="_blank" rel="noreferrer">[13]</a></sup>`,
    image: "/images/nepal/insight-2.jpg",
  },
  {
    heading:
      "Challenges related to the implementation of labour laws increase the vulnerability of migrant workers:",
    text: `In Nepal, amendments to the Labour Act in 2017 and Labour Rules in 2018, extended the applicability of the act to firms of any size. However, cases of collective bargaining, safety and health, or labour relation committees do not fall under the new amendment.<sup><a href="https://vidhilegal.com/general-introduction-to-labor-laws-in-nepal/" target="_blank" rel="noreferrer">[14]</a></sup> This could result in those working in small sized enterprises being susceptible to exploitation. Furthermore, compliance with these laws has implementation challenges. For instance, enforcement of minimum wage laws is limited, resulting in cases of workers being paid below the minimum wage.<sup><a href="https://www.spotlightnepal.com/2019/05/22/application-minimum-wages-nepal-challenges-and-opportunities/" target="_blank" rel="noreferrer">[15]</a></sup>`,
    image: "/images/nepal/insight-3.jpg",
  },
  {
    heading:
      "The Social Security Fund in Nepal was recently expanded to cover informal sector workers and self-employed individuals:",
    text: `There are 87 social security schemes in Nepal.<sup><a href="https://www.internal-displacement.org/global-report/grid2023/" target="_blank" rel="noreferrer">[16]</a></sup> One of the key schemes for workers is the Social Security Fund, launched in 2018, initially covering only formal sector workers. Recently the scheme was expanded to include informal workers and self-employed individuals. The fund includes four schemes: medical and safe maternity protection, accidents and disabilities, dependent family protection scheme, and old age protection scheme.<sup><a href="https://www.ilo.org/wcmsp5/groups/public/---asia/---ro-bangkok/---ilo-kathmandu/documents/publication/wcms_869013.pdf" target="_blank" rel="noreferrer">[17]</a></sup>`,
    image: "/images/nepal/insight-4.jpg",
  },
];
export const learnMore = [
  {
    link: "https://publications.iom.int/books/migration-nepal-country-profile-2019#:~:text=IOM%20Publications%20Platform,-Main%20navigation&text=This%20inaugural%20Migration%20Profile%20for,working%20overseas%20or%20has%20returned",
    text: "Migration in Nepal",
  },
  {
    link: "https://link.springer.com/chapter/10.1007/978-3-030-44010-7_13",
    text: "Internal Migration in Nepal",
  },
];
